import { EVENTS_FILTERS_DATA, EVENTS_FILTERS_LOADED, EVENTS_FILTERS_ERROR, EVENTS_FILTERS_APPLIED } from "../reducers/eventsFiltersReducer";

export const getEventsFiltersData = (url, params) => (dispatch) => {
	fetch(`${url}?${new URLSearchParams(params).toString()}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: EVENTS_FILTERS_DATA, payload: data._data.filters });
				dispatch({ type: EVENTS_FILTERS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: EVENTS_FILTERS_ERROR, payload: err.message });
		});
}

export const setEventsAppliedFilters = (payload) => (dispatch) => {
	dispatch({ type: EVENTS_FILTERS_APPLIED, payload });
}